module.exports = __webpack_public_path__ + "@/assets/img/019-girl-10.8b082d46.svg";